import { CancelStylesUi } from 'Shared/themes/CancelStylesUi';
import { ClassesUi } from 'Shared/themes/ClassesUi';
import { StyleEntry } from 'Shared/backend/styleUtils';


export function toolStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		'Parent styles to cancel': {
			explanation: 'Remove styles inherited from the site or parent sections.',
			ui: CancelStylesUi,
			rules: []
		},

		'Classes': {
			explanation: 'Apply classes to this component for use in style location matching.',
			ui: ClassesUi,
			rules: []
		},
	};
}

